// extracted by mini-css-extract-plugin
module.exports = {"loadScreen":"loadScreen__jvQgR","inner":"inner__Zfht7"};